export default __webpack_public_path__ + "static/media/15.9de7a413.jpg";